import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";

const faqs = [
  {
    q: "Is Audivis built by an actual Chartered Accountant?",
    a: "Yes. Every workflow, calculation and disclosure is reviewed by a practising CA — including Ind AS 116 lease accounting, ESOP valuation under SEBI/IBBI, and consolidation logic.",
  },
  {
    q: "Can I deploy Audivis on my own infrastructure?",
    a: "Audivis ships cloud-hosted out of the box, and is also self-host friendly on any cPanel host. Multi-tenant workspaces keep client data fully isolated.",
  },
  {
    q: "Which standards does LeaseLens support?",
    a: "Ind AS 116 and IFRS 16 — including initial recognition, modifications, reassessments, journal entries and full disclosure note generation.",
  },
  {
    q: "What does the ESOP Valuation tool generate?",
    a: "A signed-off-ready PDF report with Black-Scholes inputs, peer-set volatility, sensitivity tables, multi-tranche / multi-grant support and DLOM analysis.",
  },
  {
    q: "How are approvals and audit trails handled?",
    a: "Role-based access (Owner / Admin / Editor / Viewer) with multi-user approval workflows, threaded comments and immutable audit logs on every action.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      className="relative py-28 md:py-36 px-6 md:px-10 bg-[#fafaf9]"
      data-testid="faq-section"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-[11px] uppercase tracking-[0.28em] text-gray-500 font-mono-x mb-4">
          §05 · FAQ
        </div>
        <h2 className="font-display text-4xl md:text-6xl font-semibold text-[#202A36] leading-[1.02] tracking-[-0.03em] mb-14">
          Common questions,
          <span className="text-gray-400"> precise answers.</span>
        </h2>

        <div className="border-t border-black/10">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="border-b border-black/10"
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-start justify-between gap-6 text-left py-6 md:py-7 group"
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="font-display text-lg md:text-2xl font-medium text-[#202A36] tracking-tight pr-8">
                    {f.q}
                  </span>
                  <span className="shrink-0 mt-1 h-9 w-9 rounded-full border border-black/15 flex items-center justify-center text-[#202A36] group-hover:bg-[#202A36] group-hover:text-white transition-colors">
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pb-7 pr-12 text-gray-600 leading-relaxed text-[15px] md:text-base max-w-3xl">
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
